import styled from 'styled-components';

export const UserProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 0 13px 16px;
`;

export const UserName = styled.div`
  margin-left: 8px;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
`;

export const LoggedOutLinkWrapper = styled.div`
  padding: 16px 0 16px 16px;
  border-bottom: solid 1px #e9ebed;
  line-height: 24px;
  font-size: 16px;
  a {
    margin-right: 24px;
    color: #2b6ed2;
  }
`;
